module.exports = __webpack_public_path__ + "img/cloud-platforms.5ea8137.png";